<template>
    <div class="book_details_container brdr px-3" style="direction: rtl;">
        <div class="flex flex-column txt-cntr mt-3">
            <label for="publishingHouse" style="font-weight: bold;">
                {{ $t('PUBLISHING_HOUSE') }}
            </label>
            <div id="publishingHouse">
                {{ book.publishingHouse }}
            </div>
        </div>
        <Divider class="divider-color" />
        <div class="flex flex-column txt-cntr">
            <label for="publishingYear" style="font-weight: bold;">
                {{ $t('PUBLISHING_YEAR') }}
            </label>
           
            <div id="publishingYear">
                {{ book.publishingYear }}
            </div>
        </div>
        <Divider class="divider-color"/>
        <div v-if="!!book.language" class="flex flex-column txt-cntr">
            <label for="language" style="font-weight: bold;">
                {{ $t('LANGUAGE') }}
            </label>
            <div id="language">
                {{ book.language }}
            </div>
        </div>
        <Divider class="divider-color"/>
        <div v-if="!!book.pages" class="flex flex-column txt-cntr">
            <label for="pages" style="font-weight: bold;">
                {{ $t('PAGES') }}
            </label>
            <div id="pages">
                {{ book.pages }}
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onBeforeMount, inject } from 'vue'
import Divider from 'primevue/divider';


const dialogRef = inject("dialogRef")
const book = ref()

onBeforeMount(() => {
    book.value = dialogRef.value.data.book
})

</script>

<style scoped>
.book_details_container>div {
    margin-bottom: 10px;
}

.txt-cntr{
    text-align: center;
}

.divider-color{
    border-top: 1px solid #435a8523 !important;
}

.brdr{
    border: 1px solid #435a8523;
    border-radius: 15px;
}
</style>